export default {
	short_products: []
};
